<template>
  <div class="dropdown dropdown-customer show d-inline-block">
    <button
      class="btn btn-link text-bold text-12"
      type="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      aria-controls="social-media-sharing"
      id="social-media-sharing"
      arial-label="social media share"
    >
      <i class="color-white icon-share xs"></i>
      <span class="sr-only sr-only-focusable">Share</span>
    </button>
    <div
      class="dropdown-menu share-social-icon"
      aria-labelledby="social-media-sharing"
      aria-label="social-media-sharing"
      role="menu"
    >
      <div class="dropdown-menu-icon">
        <ul>
          <li v-for="media in socialMedia" :key="media.name">
            <a
              role="menuitem"
              class="dropdown-item text-14 share-button"
              rel="nofollow"
              @click.prevent="share(media)"
            >{{media.name}}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'SocialMediaMenu',
  data: () => ({
    windowSharingOptions:
      'width=600, height=400, location=0, menubar=0, resizeable=0, scrollbars=0, status=0, titlebar=0, toolbar=0'
  }),
  computed: {
    ...mapState(['socialMedia']),
    ...mapGetters(['sharingUrl'])
  },
  created () {
    this.setAvailableSocialLinks()
  },
  methods: {
    ...mapActions(['setAvailableSocialLinks', 'trackSocialMediaShare']),
    async share ({ link }) {
      this.trackSocialMediaShare()
      window.open(this.sharingUrl(link), null, this.windowSharingOptions)
    }
  }
}
</script>
